import { getCurrentContractAddresses } from "src/configs/address";
import KawaiiCoreABI from "src/contract-logic/abis/KawaiiCoreABI.json";
import { web3Reader } from "src/wallet-connection";

var contractReader = null;

function getContractReader() {
  const { KAWAII_CORE_ADDRESS } = getCurrentContractAddresses();
  if (!contractReader) {
    contractReader = new web3Reader.eth.Contract(KawaiiCoreABI, KAWAII_CORE_ADDRESS);
  }
  if (!contractReader) {
    throw new Error("Failed to create kawaii-core contract reader");
  }
  return contractReader;
}

async function getQuantity(owner, tokenId) {
  const res = await getContractReader().methods.balanceOf(owner, tokenId).call();
  return res;
}

async function getBatchQuantity(owners, tokenIds) {
  const res = await getContractReader().methods.balanceOfBatch(owners, tokenIds).call();
  return res;
}

export default {
  getQuantity,
  getBatchQuantity,
};
